export type BannerPlacement = 'home' | 'playstation';

export const SHOWCASE_FILTERS = {
  brandNew: 'Новинки',
  salesLeader: 'Лидеры продаж',
  preOrder: 'Предзаказы',
  lowestPrice: 'Дешевле не было',
  topMetacritic: 'Лучшие по Metacritic',
  multiplayer: 'Вдвоём на одном экране',
  topUpCards: 'Карты пополнения',
  discounted: 'Скидки',
} as const;

export type ShowcaseFilter = keyof typeof SHOWCASE_FILTERS;

export interface Banner {
  id: number;
  imageUrl?: string | null;
  position: number;
  placement: BannerPlacement;
  showcaseFilter?: ShowcaseFilter | null;
  categoryId?: number | null;
  categorySlug?: string | null;
  externalUrl?: string | null;
  isSharing: boolean;
}

export function showcaseCatalogUrl(filter: ShowcaseFilter): string {
  if (filter === 'topUpCards') return '/top-up-cards';
  return `/catalog?platforms=PS4&platforms=PS5&${filter}=true`;
}
